module.exports = __webpack_public_path__ + "static/media/realestate.3e6f6837.webp";